module.exports = __webpack_public_path__ + "static/img/title.9fa5016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/title.png
// module id = Af7u
// module chunks = 1